<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...$$props}>
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="m3.52 6.933 2.827-3.6L4.712 2 0 8l4.712 6 1.635-1.333-2.828-3.6H16V6.933z"
    clip-rule="evenodd"
  />
</svg>
